<template>
  <SplitContainer
    class="pb-24"
    color="#FFF6E9"
  >
    <template #head>
      <div class="grid-side-content grid gap-5 py-5 lg:pb-7 lg:pt-8">
        <div class="flex flex-col py-2.5">
          <div class="heading text-blue pb-5 font-bold">
            {{ currentPage.title }}
          </div>
        </div>
        <SofieText
          class="prose-p:font-bold"
          :value="currentPage.template.standard_text"
        />
      </div>
    </template>

    <template #split>
      <div class="h-12" />
    </template>

    <div class="grid-base -mt-12 grid-cols-1 xl:grid-cols-4">
      <div
        v-for="committee in committees"
        :key="committee.id"
        class="bg-sand flex flex-col justify-between border border-black"
      >
        <img
          v-if="committee.active_image"
          class="image aspect-long h-max lg:col-span-3 lg:aspect-[4/3]"
          :src="committee.active_image.url"
          :alt="committee.title"
        >
        <div class="flex h-full flex-col justify-between p-8">
          <div class="heading lg:text-2xl">
            {{ committee.title }}
          </div>
          <SofieText
            class="prose-p:font-medium mb-8 line-clamp-3 max-w-full text-xs lg:text-lg"
            :value="committee.template.text"
          />
          <NuxtLink
            class="text-[#849DBF] underline"
            :to="localePath({name: 'about-us-committees-slug', params: {slug: committee.slug}})"
          >
            {{ $t('Read more') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </SplitContainer>
</template>

<script setup lang="ts">
import {useCommitteesQuery} from '~/graphql/graphql';

definePageMeta({
  auth: false,
  middleware: ['sofie-page'],
});

const currentPage = useSofiePage();
const localePath = useLocalePath();

const {result} = useCommitteesQuery();
const committees = computed(() => result.value?.committees ?? []);
</script>
